import React, { useEffect, forwardRef } from 'react';
import './BurgerIcon.scss';

const BurgerIcon = forwardRef(({ isOpen, toggleMenu, isMenuClosing }, ref) => {

  useEffect(() => {
    if (isOpen) {
      const burgerSpans = document.querySelectorAll('.burger');

      const timer = setTimeout(() => {
        burgerSpans.forEach((span, index) => {
          setTimeout(() => {
            span.classList.add('slide-in');
          }, index * 300);
        });
      }, 300);

      return () => clearTimeout(timer);
    } 
  }, [isOpen]);

  return (
    <div
      className={`burger-icon ${isOpen ? 'open' : ''}`}
      onClick={toggleMenu}
      ref={ref}
    >
      <span className={`burger ${isOpen ? 'delayed' : ''}`} />
      <span className={`burger ${isOpen ? 'delayed' : ''}`} />
      <span className={`burger ${isOpen ? 'delayed' : ''}`} />
    </div>
  );
});

export default BurgerIcon;